import React from 'react';

// Simple CSS-based bar chart component
const SimpleChart = ({ data, height = '200px', color = '#3B82F6', labelKey = '_id', valueKey = 'count' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }

  const maxValue = Math.max(...data.map(item => item[valueKey] || 0));

  return (
    <div className="space-y-2" style={{ height }}>
      <div className="flex items-end justify-between h-full space-x-1">
        {data.map((item, index) => {
          const value = item[valueKey] || 0;
          const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          
          return (
            <div key={index} className="flex-1 flex flex-col items-center justify-end" style={{ height: '100%' }}>
              <div
                className="w-full rounded-t transition-all hover:opacity-80"
                style={{
                  height: `${percentage}%`,
                  backgroundColor: color,
                  minHeight: value > 0 ? '4px' : '0px'
                }}
                title={`${item[labelKey]}: ${value}`}
              />
              <p className="text-xs text-gray-600 mt-1 truncate w-full text-center" style={{ fontSize: '0.6rem' }}>
                {typeof item[labelKey] === 'string' && item[labelKey].includes('-') 
                  ? item[labelKey].split('-')[2] 
                  : item[labelKey]}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SimpleChart;

